// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"504":"7b20e0f4","556":"7b20e0f4","841":"4ec43ce2","844":"9ebec22f"}[chunkId] + ".chunk.css";
};